module.exports = __webpack_public_path__ + "media/3_34.019e9000.wav";